import { contentBlockOptions } from '@/pageTpls/TCI/TCISections/TemplateBuilder/comps/panels/InputBlockConfigPanelTCI/config/contentBlockOptions';

/**
 * Derives a { comp → iconName } map from contentBlockOptions.
 * Flattens variants and picks up the `icon` field from each entry.
 *
 * e.g. { TextInput: 'TextT', NumberInput: 'Hash', DropdownSingle: 'RadioButton', ... }
 */
const buildCompIconMap = () => {
  const iconMap = {};
  const weightMap = {};
  contentBlockOptions
    .reduce((acc, next) => [...acc, ...(next.variants || [next])], [])
    .forEach(entry => {
      if (entry.comp && entry.icon) {
        iconMap[entry.comp] = entry.icon;
        if (entry.iconWeight) weightMap[entry.comp] = entry.iconWeight;
      }
    });
  return { iconMap, weightMap };
};

const { iconMap, weightMap } = buildCompIconMap();
export const COMP_ICON_MAP = iconMap;
export const COMP_ICON_WEIGHT_MAP = weightMap;
